export enum ESubscriptionType {
  TRIAL = "TRIAL",
  TEAM = "TEAM",
  DEVELOPER = "DEVELOPER"
}
